import SeasonalBanner, {
  SeasonalBannerColors,
} from "../../SeasonalBanner/SeasonalBanner"
import svg from "../../../utils/svg"
import useStrings from "../../../localization/useStrings"

const autumnColors: SeasonalBannerColors = {
  containerBackground: "linear-gradient(to bottom, #FFE9CA 0%, #FE9448 100%)",
  titleText: "#B92E3D",
  subtitleText: "#6D260B",
  urgencyText: "#6D260B",
  countdownBox: "rgba(255, 226, 188, 0.8)",
  countdownValue: "#30343D",
  countdownLabel: "#6D260B",
  ctaBackground: "#B92E3D",
  ctaText: "#FFE2BC",
}

const AutumnBanner = () => {
  const strings = useStrings()

  return (
    <SeasonalBanner
      icon={<svg.autumn.BannerIcon />}
      title={strings.autumnSale.title}
      colors={autumnColors}
      titleFontSize="18px"
    />
  )
}

export default AutumnBanner
